import API from "./API";

export default class System extends API
{
    static async status() {
        return this.get("api/admin/system/status");
    }

    static async getStatus(params) {
        return await System.getAxiosInstance().get('api/admin/system/get-status', params);
    }
}